import { render, staticRenderFns } from "./HistoryDatasetDisplay.vue?vue&type=template&id=cf21cf74&scoped=true"
import script from "./HistoryDatasetDisplay.vue?vue&type=script&lang=js"
export * from "./HistoryDatasetDisplay.vue?vue&type=script&lang=js"
import style0 from "./HistoryDatasetDisplay.vue?vue&type=style&index=0&id=cf21cf74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf21cf74",
  null
  
)

export default component.exports